/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useCallback, useMemo, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Badge,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Collapse,
  Container,
  Fade,
  Form,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  UncontrolledTooltip,
} from 'reactstrap';

import classNames from 'classnames';
import { format, parseISO, getYear, getMonth, subYears } from 'date-fns';
// import { ptBR } from 'date-fns/locale';
import * as Yup from 'yup';

import AlertModal from '../../components/AlertModal';
import CustomModal from '../../components/CustomModal';
import DatePickerMaskedInput from '../../components/DatePickerMaskedInput';
// import CustomModalEmitirFatura from '../../components/Financeiro/CustomModalEmitirFatura';
import CustomModalFecharFatura from '../../components/Financeiro/CustomModalFecharFatura';
import CustomModalFecharFaturas from '../../components/Financeiro/CustomModalFecharFaturas';
import CustomModalMotivoCancelamento from '../../components/Financeiro/CustomModalMotivoCancelamento';
import CustomModalPagarFatura from '../../components/Financeiro/CustomModalPagarFatura';
import CustomModalPagarFaturas from '../../components/Financeiro/CustomModalPagarFaturas';
import FinanceiroEdit from '../../components/Financeiro/Edit';
import ModalContaReceberTableInfo from '../../components/ModalFinanceiroTableInfo';
import TableManager from '../../components/TableManager';
import { AppContext } from '../../contexts/app';
import { useManager } from '../../hooks/manager';
import api from '../../services/api';
import { numberToCurrency, objectToFormattedString, objectToFieldValueArrayString } from '../../utils/functions';

const months = [
  { value: 1, label: 'Jan' },
  { value: 2, label: 'Fev' },
  { value: 3, label: 'Mar' },
  { value: 4, label: 'Abr' },
  { value: 5, label: 'Mai' },
  { value: 6, label: 'Jun' },
  { value: 7, label: 'Jul' },
  { value: 8, label: 'Ago' },
  { value: 9, label: 'Set' },
  { value: 10, label: 'Out' },
  { value: 11, label: 'Nov' },
  { value: 12, label: 'Dez' },
];

const COLUMNS_STORAGE_KEY_CONTAS_RECEBER = 'table-manager-contas-receber-agrupado-columns';
const DEFAULT_HIDDEN_COLUMNS_CONTAS_RECEBER = ['observacao'];

function ContasReceberAgrupado() {
  const navigate = useNavigate();
  const alertRef = useRef();
  const modal = useRef();
  const modalFinanceiroEdit = useRef();
  // const modalEmitirFatura = useRef();
  const modalFecharFatura = useRef();
  const modalFecharFaturas = useRef();
  const modalPagarFaturas = useRef();
  const modalPagarFatura = useRef();
  const modalMotivoCancelamento = useRef();
  const modalContaReceberTableInfo = useRef();
  const { setLoading, notificationRef } = useContext(AppContext);
  const {
    load,
    // update,
    // destroy,
    extraData: {
      totalContaPagar = 0,
      totalContaReceber = 0,
    },
  } = useManager();
  const [selectedRows, setSelectedRows] = useState([]);
  const [showCloseFinanceiroModal, setShowCloseFinanceiroModal] = useState(false);
  const [dataCloseFinanceiroInicio, setDataCloseFinanceiroInicio] = useState('');
  const [dataCloseFinanceiroTermino, setDataCloseFinanceiroTermino] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const [searchArray, setSearchArray] = useState([]);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [, setUpdateInterval] = useState(null);
  const [showUpdateDetails, setShowUpdateDetails] = useState(false);
  const [selectedColumnsDataFields, setSelectedColumnsDataFields] = useState([]);

  const handleToggleModalContaPagarTableInfo = (row) => {
    console.log('🚀 ~ handleToggleModalContaPagarTableInfo ~ row:', row);
    modalContaReceberTableInfo.current.show({
      query: `/financeiros-contas-receber?search=${objectToFieldValueArrayString(row._id)}`,
      title: 'Contas a Receber - Detalhes',
      type: 'conta-receber',
      visibleColumnsDataFields: selectedColumnsDataFields,
    });
  };

  useEffect(() => {
    load('/financeiros-contas-receber-grouped', 1, []);
  }, [load]);

  // Cleanup do intervalo quando o componente for desmontado
  useEffect(() => () => {
    setUpdateInterval((currentInterval) => {
      if (currentInterval) {
        clearInterval(currentInterval);
      }
      return null;
    });
  }, []);

  const reload = useCallback(() => {
    // console.log('current base url', currentUrl, 'page number', pageNumber);
    setSelectedRows([]);
    load('/financeiros-contas-receber-grouped', 1, searchArray, 10);
  }, [load, searchArray]);

  const checkUpdateStatus = useCallback(async () => {
    try {
      const response = await api.get('/financeiros-contas-receber-materialized-view-progress');
      setUpdateStatus(response.data);

      console.log('🚀 ~ checkUpdateStatus ~ response.data.data.isUpdating:', !response.data.data.isUpdating);
      if (!response.data.data.isUpdating) {
        setIsUpdating(false);
        setUpdateInterval((currentInterval) => {
          if (currentInterval) {
            clearInterval(currentInterval);
          }
          return null;
        });
        reload();
      }
    } catch (err) {
      console.error('Erro ao verificar status da atualização:', err);
      setIsUpdating(false);
      setUpdateInterval((currentInterval) => {
        if (currentInterval) {
          clearInterval(currentInterval);
        }
        return null;
      });
    }
  }, []);

  const startFinancialDataUpdate = useCallback(async () => {
    try {
      setLoading({
        loading: true,
        message: 'Iniciando atualização dos dados financeiros...',
      });

      // Inicia a atualização
      await api.get('/financeiros-contas-receber-materialized-view-full-refresh');

      setLoading(false);
      setShowUpdateModal(true);
      setIsUpdating(true);
      setUpdateStatus(null);

      // Inicia o monitoramento do status
      const interval = setInterval(checkUpdateStatus, 2000); // Verifica a cada 2 segundos
      setUpdateInterval(interval);

      // Primeira verificação imediata
      checkUpdateStatus();

      notificationRef.current.notify({
        message: 'Atualização dos dados financeiros iniciada com sucesso',
        color: 'success',
      });
    } catch (err) {
      setLoading(false);
      console.error('Erro ao iniciar atualização:', err);

      if (err && err.response && err.response.data) {
        const { message } = err.response.data;
        notificationRef.current.notify({
          message: message || 'Falha ao iniciar atualização dos dados financeiros',
          color: 'danger',
        });
      } else {
        notificationRef.current.notify({
          message: 'Falha ao iniciar atualização dos dados financeiros',
          color: 'danger',
        });
      }
    }
  }, [setLoading, checkUpdateStatus, notificationRef]);

  const closeUpdateModal = useCallback(() => {
    setShowUpdateModal(false);
    setUpdateInterval((currentInterval) => {
      if (currentInterval) {
        clearInterval(currentInterval);
      }
      return null;
    });
    setIsUpdating(false);
    setUpdateStatus(null);
  }, []);

  const handleFecharFaturaSelecionadas = useCallback(() => {
    modalFecharFaturas.current.show({
      selectedRows,
      onReload: reload,
    });
  }, [selectedRows, reload]);

  const handlePagarFaturaSelecionadas = useCallback(() => {
    modalPagarFaturas.current.show({
      selectedRows,
      onReload: reload,
    });
  }, [selectedRows, reload]);

  const handleCloseFinanceiro = useCallback(() => {
    (async () => {
      try {
        const validationData = {
          dataCloseFinanceiroInicio,
          dataCloseFinanceiroTermino,
        };

        const schema = Yup.object().shape({
          dataCloseFinanceiroInicio: Yup.string().required('Informe a data de início'),
          dataCloseFinanceiroTermino: Yup.string().required('Informe a data de término'),
        });

        await schema.validate(validationData, {
          abortEarly: false,
        });
        setLoading(true);

        const data = {
          dataInicio: dataCloseFinanceiroInicio,
          dataTermino: dataCloseFinanceiroTermino,
        };

        await api.post('/financeiroPeriodos', data);
        setLoading(false);
        notificationRef.current.notify({
          message: 'Financeiro fechado com sucesso',
        });
      } catch (err) {
        setLoading(false);
        console.log(err);
        setValidationErrors({});
        // Validation failed
        if (err instanceof Yup.ValidationError) {
          notificationRef.current.notify({
            message: 'Por favor, preencha todos os dados necessários para salvar',
            color: 'warning',
          });
          const ve = {};
          err.inner.forEach((e) => {
            ve[e.path] = e.message;
          });
          setValidationErrors(ve);
          return;
        }

        if (err && err.response && err.response.data) {
          const { message } = err.response.data;
          notificationRef.current.notify({
            message,
            color: 'danger',
          });

          return;
        }

        notificationRef.current.notify({
          message: 'Algo inesperado aconteceu e não foi possível salvar',
          color: 'danger',
        });
      }
    })();
  }, [dataCloseFinanceiroInicio, dataCloseFinanceiroTermino]);

  const tipoFormatter = useCallback((row) => {
    if (row?.tipo === 'conta-pagar') {
      return (
        <Badge className="w-100" color="danger" tag="div">
          <i className="fa-solid fa-money-bill-transfer mr-2" />
          a Pagar
        </Badge>
      );
    }

    if (row?.tipo === 'conta-receber') {
      return (
        <Badge className="w-100" color="success" tag="div">
          <i className="fa-solid fa-hand-holding-dollar mr-2" />
          a Receber
        </Badge>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`tipo-${objectToFormattedString(row._id)}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`tipo-${objectToFormattedString(row._id)}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const statusFormatter = useCallback((row) => {
    if (row?.atendimentoStatus === 'cancelado') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`agendamento-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-calendar-xmark text-danger mr-2" />
            Cancelado
          </span>
        </span>
      );
    }

    if (row?.fatura === 'aberto') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`status-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-circle text-success mr-2" />
            Em Aberto
          </span>
        </span>
      );
    }

    if (row?.fatura === 'fechado') {
      if (row?.atendimentoStatus === 'cancelado') {
        return (
          <span className="d-flex w-100 justify-content-between align-items-center">
            <span id={`status-${objectToFormattedString(row._id)}`}>
              <i className="fa-solid fa-circle text-warning mr-2" />
              Fechado
            </span>
          </span>
        );
      }
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`status-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-circle text-warning mr-2" />
            Fechado
          </span>
        </span>
      );
    }

    if (row?.fatura === 'emitido') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`status-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-circle text-danger mr-2" />
            Emitido
          </span>
        </span>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`status-${objectToFormattedString(row._id)}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`status-${objectToFormattedString(row._id)}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  /* const folhaPagamentoHumanReadableFormatter = useCallback((row) => {
    if (row?.contaDe === 'fornecedor') {
      return (
        <>
          <i className="fa-solid fa-building-user text-success mr-2" />
          Não Emite
        </>
      );
    }

    if (!row?.folhaPagamentoHumanReadable) {
      return (
        <>
          <i className="fa-solid fa-spinner text-warning mr-2" />
          Não Gerado
        </>
      );
    }

    return (
      <>
        <i className="fa-solid fa-hashtag text-danger mr-2" />
        {row?.folhaPagamentoHumanReadable}
      </>
    );
  }, []); */

  const situacaoFormatter = useCallback((row) => {
    if (row?.atendimentoStatus === 'cancelado') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`agendamento-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-calendar-xmark text-danger mr-2" />
            Cancelado
          </span>
        </span>
      );
    }

    if (row?.situacao === 'a-vencer') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`situacao-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-circle-info text-info mr-2" />
            A Vencer
          </span>
        </span>
      );
    }

    if (row?.situacao === 'pago') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`situacao-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-circle-check text-success mr-2" />
            Pago
          </span>
        </span>
      );
    }

    if (row?.situacao === 'vencido') {
      return (
        <span className="d-flex w-100 justify-content-between align-items-center">
          <span id={`situacao-${objectToFormattedString(row._id)}`}>
            <i className="fa-solid fa-circle-xmark text-danger mr-2" />
            Vencido
          </span>
        </span>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`situacao-${objectToFormattedString(row._id)}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`situacao-${objectToFormattedString(row._id)}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const nameFormatter = useCallback((row) => {
    if (row?.clienteNome) {
      return (
        <div className="d-flex align-items-center">
          <UncontrolledTooltip target={`nome-tipo-${objectToFormattedString(row._id)}`}>
            Paciente
          </UncontrolledTooltip>
          <i
            id={`nome-tipo-${objectToFormattedString(row._id)}`}
            className="fa-solid fa-user text-success mr-2"
          />
          {row.clienteNome}
        </div>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`nome-tipo-${objectToFormattedString(row._id)}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`nome-tipo-${objectToFormattedString(row._id)}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const responsavelFinanceiroFormatter = useCallback((row) => {
    const responsavelFinanceiro = row?.adminFaturamentoName || row?.adminFaturamento?.name;

    if (responsavelFinanceiro) {
      return (
        <div className="d-flex align-items-center">
          <UncontrolledTooltip target={`responsavel-financeiro-${objectToFormattedString(row._id)}`}>
            Responsável Financeiro
          </UncontrolledTooltip>
          <i
            id={`responsavel-financeiro-${objectToFormattedString(row._id)}`}
            className="fa-solid fa-user-tie text-primary mr-2"
          />
          {responsavelFinanceiro}
        </div>
      );
    }

    return (
      <>
        <UncontrolledTooltip target={`responsavel-financeiro-${objectToFormattedString(row._id)}`}>
          Não Identificado
        </UncontrolledTooltip>
        <i
          id={`responsavel-financeiro-${objectToFormattedString(row._id)}`}
          className="fa-solid fa-circle-question text-danger mt-2"
        />
      </>
    );
  }, []);

  const observacaoFormatter = useCallback((row) => {
    if (row?.observacao) {
      return (
        <>
          <UncontrolledTooltip target={`observacao-${objectToFormattedString(row._id)}`}>
            {row.observacao}
          </UncontrolledTooltip>
          <i
            id={`observacao-${objectToFormattedString(row._id)}`}
            className="fa-solid fa-info-circle text-info"
          />
        </>
      );
    }

    return (
      <i className="fa-solid fa-minus text-muted" />
    );
  }, []);

  const dataFechamentoFormatter = useCallback((row) => {
    if (typeof row.datafechamento === 'string') {
      return format(parseISO(row.datafechamento), 'dd/MM/yyyy');
    }

    if (typeof row.datafechamento === 'object' && row?.datafechamento?.dia) {
      return format(new Date(row.datafechamento.ano, row.datafechamento.mes - 1, row.datafechamento.dia), 'dd/MM/yyyy');
    }

    if (row.datafechamento) {
      return row.datafechamento;
    }

    return 'Sem Fechamento';
  }, []);

  const dataVencimentoFormatter = useCallback((row) => {
    if (typeof row.dataVencimento === 'string') {
      return format(parseISO(row.dataVencimento), 'dd/MM/yyyy');
    }

    if (typeof row.dataVencimento === 'object' && row?.dataVencimento?.dia) {
      return format(new Date(row.dataVencimento.ano, row.dataVencimento.mes - 1, row.dataVencimento.dia), 'dd/MM/yyyy');
    }

    if (row.dataVencimento) {
      return row.dataVencimento;
    }

    return 'Sem Vencimento';
  }, []);

  const dataEmissaoFormatter = useCallback((row) => {
    if (typeof row.dataEmissao === 'string') {
      return format(parseISO(row.dataEmissao), 'dd/MM/yyyy HH:mm');
    }

    if (typeof row.dataEmissao === 'object' && row?.dataEmissao?.dia) {
      return format(new Date(row.dataEmissao.ano, row.dataEmissao.mes - 1, row.dataEmissao.dia), 'dd/MM/yyyy');
    }

    if (row.dataEmissao) {
      return row.dataEmissao;
    }

    return 'Sem Emissão';
  }, []);

  const dataPagamentoFormatter = useCallback((row) => {
    if (typeof row.dataPagamento === 'string') {
      return format(parseISO(row.dataPagamento), 'dd/MM/yyyy HH:mm');
    }

    if (typeof row.dataPagamento === 'object' && row?.dataPagamento?.dia) {
      return format(new Date(row.dataPagamento.ano, row.dataPagamento.mes - 1, row.dataPagamento.dia), 'dd/MM/yyyy');
    }

    if (row.dataPagamento) {
      return row.dataPagamento;
    }

    return 'Sem Pagamento';
  }, []);

  const mesFilter = useMemo(
    () => {
      const currentYear = new Date().getFullYear();
      const nextYear = currentYear + 1;
      const previousYear = currentYear - 1;

      const filters = [];

      // Adiciona meses do ano anterior
      months.forEach((month) => {
        filters.push({
          value: `${month.value}-${previousYear}`,
          label: `${month.label}/${previousYear}`,
        });
      });

      // Adiciona meses do ano atual
      months.forEach((month) => {
        filters.push({
          value: `${month.value}-${currentYear}`,
          label: `${month.label}/${currentYear}`,
        });
      });

      // Adiciona meses do próximo ano
      months.forEach((month) => {
        filters.push({
          value: `${month.value}-${nextYear}`,
          label: `${month.label}/${nextYear}`,
        });
      });

      return filters;
    },
    [],
  );

  const statusFilter = useMemo(
    () => [
      {
        value: 'aberto',
        label: 'Em aberto',
      },
      {
        value: 'fechado',
        label: 'Fechado',
      },
      {
        value: 'emitido',
        label: 'Emitido',
      },
    ],
    [],
  );

  const situacaoFilter = useMemo(
    () => [
      {
        value: 'a-vencer',
        label: 'A Vencer',
      },
      {
        value: 'pago',
        label: 'Pago',
      },
      {
        value: 'vencido',
        label: 'Vencido',
      },
    ],
    [],
  );

  const columns = useMemo(
    () => [
      {
        dataField: 'tipo',
        text: 'Módulo',
        formatter: tipoFormatter,
        className: 'text-center',
        width: '50px',
      },
      {
        dataField: 'adminFaturamentoName',
        text: 'Responsável Financeiro',
        textFilter: true,
        formatter: responsavelFinanceiroFormatter,
        width: '100%',
      },
      {
        dataField: 'name',
        text: 'Paciente',
        textFilter: true,
        formatter: nameFormatter,
        width: '100%',
      },
      {
        dataField: 'mesAtendimento',
        text: 'Mês/Ano',
        selectFilter: mesFilter,
        initValue: getMonth(new Date()) === 0 ? `${months.find((month) => month.value === getMonth(new Date()))?.value}-${getYear(new Date())}` : `${months.find((month) => month.value === 12)?.value}-${getYear(subYears(new Date(), 1), 1)}`,
        formatter: (row) => (row.mes && row.ano ? `${months.find((month) => month.value === parseInt(row.mes, 10)).label}/${row.ano}` : '-'),
        className: 'text-center',
        width: '120px',
      },
      {
        dataField: 'sub-total',
        text: 'Sub-Total',
        formatter: (row) => `${numberToCurrency(row?.total || 0)}`,
        width: '100px',
        dataType: 'money',
      },
      {
        dataField: 'reembolso',
        text: 'Reembolsos',
        formatter: (row) => `${numberToCurrency(row?.totalReembolso || 0)}`,
        width: '100px',
        dataType: 'money',
      },
      {
        dataField: 'outros-debitos-creditos',
        text: 'Débitos e Créditos',
        formatter: (row) => `${numberToCurrency(row?.outrosDebitosCreditos || 0)}`,
        width: '100px',
        dataType: 'money',
      },
      {
        dataField: 'total',
        text: 'Total Mês',
        formatter: (row) => `${numberToCurrency((row?.total || 0) + (row?.totalReembolso || 0) + (row?.outrosDebitosCreditos || 0))} (${row?.qty})`,
        width: '100px',
        dataType: 'money',
      },
      {
        dataField: 'status',
        text: 'Fatura',
        selectFilter: statusFilter,
        formatter: statusFormatter,
        className: 'text-center',
      },
      /* {
        dataField: 'folhaPagamentoHumanReadable',
        text: 'Nº Fatura',
        textFilter: true,
        formatter: folhaPagamentoHumanReadableFormatter,
      }, */
      {
        dataField: 'situacao',
        text: 'Situação',
        selectFilter: situacaoFilter,
        formatter: situacaoFormatter,
        className: 'text-center',
      },
      {
        dataField: 'dataFechamento',
        text: 'Fechamento',
        dateFilter: true,
        formatter: dataFechamentoFormatter,
        width: '100px',
        editable: (row) => row.status === 'aberto',
        dataType: 'date',
      },
      {
        dataField: 'dataVencimento',
        text: 'Vencimento',
        dateFilter: true,
        formatter: dataVencimentoFormatter,
        width: '100px',
        editable: (row) => row.status === 'aberto',
        dataType: 'date',
      },
      {
        dataField: 'dataEmissao',
        text: 'Emissão',
        dateFilter: true,
        formatter: dataEmissaoFormatter,
        width: '100px',
      },
      {
        dataField: 'dataPagamento',
        text: 'Pgto.',
        dateFilter: true,
        formatter: dataPagamentoFormatter,
        width: '100px',
      },
      {
        dataField: 'observacao',
        text: 'OBS',
        formatter: observacaoFormatter,
        width: '50px',
      },
    ],
    [],
  );

  const initialSelectedColumns = useMemo(() => {
    let saved;
    try {
      saved = JSON.parse(localStorage.getItem(COLUMNS_STORAGE_KEY_CONTAS_RECEBER));
    } catch {
      saved = null;
    }
    const dataFields = Array.isArray(saved) && saved.length > 0 ? saved : null;
    if (dataFields) {
      const RESPONSAVEL_FINANCEIRO_FIELD = 'adminFaturamentoName';
      const fieldsWithNewColumn = dataFields.includes(RESPONSAVEL_FINANCEIRO_FIELD)
        ? dataFields
        : [
          ...dataFields.slice(0, Math.max(dataFields.indexOf('name'), 0)),
          RESPONSAVEL_FINANCEIRO_FIELD,
          ...dataFields.slice(Math.max(dataFields.indexOf('name'), 0)),
        ];

      return columns.filter((c) => fieldsWithNewColumn.includes(c.dataField));
    }
    return columns.filter((c) => !DEFAULT_HIDDEN_COLUMNS_CONTAS_RECEBER.includes(c.dataField));
  }, [columns]);

  useEffect(() => {
    setSelectedColumnsDataFields(initialSelectedColumns.map((column) => column.dataField));
  }, [initialSelectedColumns]);

  const handleColumnsChange = useCallback((cols) => {
    const dataFields = cols.map((c) => c.dataField);
    setSelectedColumnsDataFields((prev) => {
      if (prev.length === dataFields.length && prev.every((field, index) => field === dataFields[index])) {
        return prev;
      }
      return dataFields;
    });
    localStorage.setItem(COLUMNS_STORAGE_KEY_CONTAS_RECEBER, JSON.stringify(dataFields));
  }, []);

  return (
    <Container fluid>
      <AlertModal ref={alertRef} />
      <FinanceiroEdit ref={modalFinanceiroEdit} />
      <CustomModal ref={modal} />
      <CustomModalFecharFatura ref={modalFecharFatura} />
      <CustomModalFecharFaturas ref={modalFecharFaturas} />
      <CustomModalPagarFaturas ref={modalPagarFaturas} />
      <CustomModalPagarFatura ref={modalPagarFatura} />
      <CustomModalMotivoCancelamento ref={modalMotivoCancelamento} />
      <ModalContaReceberTableInfo ref={modalContaReceberTableInfo} />
      <Row className="mt-5">
        <Col>
          <Card>
            <CardBody>
              <Row>
                <Col>
                  <h3>Contas a Receber</h3>
                </Col>
              </Row>
            </CardBody>
            <CardFooter>
              <Row>
                <Col xs={12} md={6} lg={4}>
                  <Card color="danger">
                    <CardHeader tag="h4" className="text-white text-truncate">
                      Contas a Pagar
                    </CardHeader>
                    <CardBody className="bg-pink">
                      <div className="d-flex flex-wrap align-items-center">
                        <i className="fa-solid fa-money-bill-transfer text-white mr-3" style={{ fontSize: '1.75rem' }} />
                        <Fade>
                          <span className="text-white" style={{ fontSize: '2.25rem' }}>{numberToCurrency(totalContaPagar)}</span>
                        </Fade>
                      </div>
                    </CardBody>
                    {/* <CardFooter>
                      <Button color="link" className="text-white text-decoration-none" onClick={() => navigate('/conta-pagar')} block>
                        Criar Conta a Pagar
                      </Button>
                    </CardFooter> */}
                  </Card>
                </Col>
                <Col xs={12} md={6} lg={4}>
                  <Card color="success">
                    <CardHeader tag="h4" className="text-white text-truncate">
                      Contas a Receber
                    </CardHeader>
                    <CardBody>
                      <div className="d-flex flex-wrap align-items-center">
                        <i className="fa-solid fa-hand-holding-dollar text-white mr-3" style={{ fontSize: '1.75rem' }} />
                        <Fade>
                          <span className="text-white" style={{ fontSize: '2.25rem' }}>{numberToCurrency(totalContaReceber)}</span>
                        </Fade>
                      </div>
                    </CardBody>
                    {/* <CardFooter>
                      <Button color="link" className="text-white text-decoration-none" onClick={() => navigate('/conta-receber')} block>
                        Criar Conta a Receber
                      </Button>
                    </CardFooter> */}
                  </Card>
                </Col>
                <Col xs={12} md={12} lg={4}>
                  <Card color="info">
                    <CardHeader tag="h4" className="text-white text-truncate">
                      Saldo
                    </CardHeader>
                    <CardBody>
                      <div className="d-flex flex-wrap align-items-center">
                        <i className={classNames('fa-solid fa-sack-dollar mr-3', { 'text-white': (totalContaReceber - totalContaPagar >= 0), 'text-danger': (totalContaReceber - totalContaPagar < 0) })} style={{ fontSize: '1.75rem' }} />
                        <Fade>
                          <span className={classNames({ 'text-white': (totalContaReceber - totalContaPagar >= 0), 'text-danger': (totalContaReceber - totalContaPagar < 0) })} style={{ fontSize: '2.25rem' }}>{numberToCurrency(totalContaReceber - totalContaPagar)}</span>
                        </Fade>
                      </div>
                    </CardBody>
                    {/* <CardFooter>
                      <Button color="link" className="text-white text-decoration-none" style={{ cursor: 'default' }} onClick={() => null} block>
                        Saldo
                      </Button>
                    </CardFooter> */}
                  </Card>
                </Col>
              </Row>
            </CardFooter>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col tag="div" className="d-flex flex-column" style={{ paddingLeft: '2.25rem', width: '100%', maxWidth: '600px' }}>
          {selectedRows.length ? (
            <Button
              color="info"
              className={classNames('mr-2 mb-2')}
              onClick={handleFecharFaturaSelecionadas}
            >
              Fechar Financeiro em Lote
            </Button>
          ) : null}
          {selectedRows.length ? (
            <Button color="success" className={classNames('mr-2 mb-2')} onClick={handlePagarFaturaSelecionadas}>
              Pagar Faturas em Lote
            </Button>
          ) : null}
          <Button
            color="primary"
            className={classNames('mr-2 mb-2')}
            onClick={startFinancialDataUpdate}
            disabled={isUpdating}
          >
            <i className="fa-solid fa-sync-alt mr-2" />
            {isUpdating ? 'Atualizando...' : 'Atualizar Dados Financeiros'}
          </Button>
        </Col>
      </Row>
      <Row>
        <Col>
          <TableManager
            initialColumns={columns}
            initialSelectedColumns={initialSelectedColumns}
            onUpdate={(row) => handleToggleModalContaPagarTableInfo(row)}
            onSelectedRows={(rows) => {
              console.log(rows);
              setSelectedRows(rows);
            }}
            onClickRow={(row) => handleToggleModalContaPagarTableInfo(row)}
            onColumnsChange={handleColumnsChange}
            selectable
            selectableColumns
            enableDeletedItemsButton={false}
            enableDeletedItemButton={false}
            onSearchArray={(_searchArray) => setSearchArray(_searchArray)}
          />
        </Col>
      </Row>
      <Modal
        isOpen={showCloseFinanceiroModal}
        toggle={() => setShowCloseFinanceiroModal(!showCloseFinanceiroModal)}
        centered
      >
        <ModalHeader>
          <strong>Fechar Financeiro por período</strong>
          <Button
            className="close position-absolute top-4 right-4 py-1 px-2"
            onClick={() => setShowCloseFinanceiroModal(false)}
          >
            <i className="fas fa-times" />
          </Button>
        </ModalHeader>
        <ModalBody>
          <Form>
            <Row>
              <Col xs={6}>
                <DatePickerMaskedInput
                  label="Data de"
                  placeholderText="Data de"
                  selected={dataCloseFinanceiroInicio}
                  invalidMessage={validationErrors.dataCloseFinanceiroInicio}
                  onChange={(date) => setDataCloseFinanceiroInicio(date)}
                />
              </Col>
              <Col xs={6}>
                <DatePickerMaskedInput
                  label="Data até"
                  placeholderText="Data até"
                  selected={dataCloseFinanceiroTermino}
                  invalidMessage={validationErrors.dataCloseFinanceiroTermino}
                  onChange={(date) => setDataCloseFinanceiroTermino(date)}
                />
              </Col>
            </Row>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={handleCloseFinanceiro}>Fechar Financeiro nesse período</Button>
        </ModalFooter>
      </Modal>

      {/* Modal de Atualização dos Dados Financeiros */}
      <Modal
        isOpen={showUpdateModal}
        toggle={closeUpdateModal}
        centered
        size="lg"
      >
        <ModalHeader>
          <strong>Atualização dos Dados Financeiros</strong>
          <Button
            className="close position-absolute top-4 right-4 py-1 px-2"
            onClick={closeUpdateModal}
          >
            <i className="fas fa-times" />
          </Button>
        </ModalHeader>
        <ModalBody>
          {isUpdating && !updateStatus ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Carregando...</span>
              </div>
              <p className="mt-3 mb-0">Iniciando atualização dos dados financeiros...</p>
            </div>
          ) : updateStatus ? (
            <div>
              <Row className="mb-3">
                <Col>
                  <div className="d-flex align-items-center">
                    <i className={`fa-solid fa-circle mr-2 ${updateStatus.data.isUpdating ? 'text-warning' : 'text-success'}`} />
                    <strong>
                      {updateStatus.data.isUpdating ? 'Atualização em andamento...' : 'Atualização concluída!'}
                    </strong>
                  </div>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col>
                  <Button
                    color="link"
                    className="p-0 text-decoration-none"
                    onClick={() => setShowUpdateDetails(!showUpdateDetails)}
                  >
                    <i className={`fa-solid fa-chevron-${showUpdateDetails ? 'up' : 'down'} mr-2`} />
                    Ver informações detalhadas da atualização
                  </Button>
                </Col>
              </Row>

              <Collapse isOpen={showUpdateDetails}>
                <Row className="mb-3">
                  <Col xs={6}>
                    <Card color="success" className="text-center">
                      <CardBody>
                        <h5 className="text-white">{updateStatus.data.viewCount}</h5>
                        <small className="text-white">Registros Atualizados</small>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xs={6}>
                    <Card color="dark" className="text-center">
                      <CardBody>
                        <h5 className="text-white">{updateStatus.data.originalCount}</h5>
                        <small className="text-white">Registros Originais</small>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>

                <Row className="mb-3">
                  <Col xs={6}>
                    <Card color={updateStatus.data.difference === 0 ? 'info' : 'warning'} className="text-center">
                      <CardBody>
                        <h5 className="text-white">{updateStatus.data.difference}</h5>
                        <small className="text-white">Diferença</small>
                      </CardBody>
                    </Card>
                  </Col>
                  <Col xs={6}>
                    <Card color="primary" className="text-center">
                      <CardBody>
                        <h6 className="text-white">
                          {updateStatus.data.lastUpdated
                            ? format(parseISO(updateStatus.data.lastUpdated), 'dd/MM/yyyy HH:mm:ss')
                            : 'N/A'}
                        </h6>
                        <small className="text-white">Última Atualização</small>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
              </Collapse>

              {updateStatus.data.isUpdating && (
                <Row className="mt-3">
                  <Col>
                    <div className="progress">
                      <div
                        className="progress-bar progress-bar-striped progress-bar-animated"
                        role="progressbar"
                        style={{ width: '100%' }}
                      >
                        Processando...
                      </div>
                    </div>
                  </Col>
                </Row>
              )}
            </div>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={closeUpdateModal}
            disabled={isUpdating}
          >
            {isUpdating ? 'Atualizando...' : 'Fechar'}
          </Button>
        </ModalFooter>
      </Modal>
    </Container>
  );
}

export default ContasReceberAgrupado;
